import React, { useEffect } from 'react';
import DownArrow from '@material-ui/icons/ExpandMore';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";


const DropDown = styled.div`
  overflow-y: scroll;
  max-height: 300px;
  min-width: 250px;

  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
  
  ::-webkit-scrollbar-thumb {
    background: #888; 
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
`

const DropDownBtn = styled.button`
 
`

const DropDownRow = styled.button`
  font-family: 'Roboto';
  &:hover{
    background: #e9e9e9 !important;
  }
`

//Fix for alignemnt issue. Reduced padding to 5
const ActionDropDownContainer = styled.div`
  display: flex;
  align-items: center;
  // width: 310px;
  background: #E6E6E6;
  padding: 6px 16px 5px 16px; 
  justify-content: space-between;
  margin-right: auto;
  p{
    margin: 0;
  }
`

const ItemCounter = styled.p`
  font-weight: 500;
`

const ClearAll = styled.p`
  padding: 0 20px;
  color: #D70015;
  font-weight: 500;
  cursor: pointer;
`

const useStyles = makeStyles((theme) => ({
  btnHeader: {
    background: '#c3c3c3 !important',
    padding: '8px 16px !important',
    color: '#000 !important',
    fontSize: '15px',
    fontWweight: 500,
    fontFamily: 'Roboto',
    cursor: 'not-allowed !important',
    "&:hover": {
      background: '#c3c3c3 !important',
      color: '#000 !important',
    }
  },
  buttonStyle: {
    margin: '0',
    padding: '6px 10px !important'
  }
}));

const ActionDropDown = (props) => {

  const classs = useStyles();
  const { t } = useTranslation()
  useEffect(() => {
    window.onclick = function (event) {
      if (!event.target.matches('.dropbtn')) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    }
  })

  return (

    <ActionDropDownContainer style={{ display: props.selectedRows ? 'flex' : 'none' }}>

      {!props.hideselectedCount ?
        <ItemCounter>{`${props.selectedRows} ${t('item')}${props.selectedRows < 2 ? '' : 's'} ${t('selected')}`}</ItemCounter>
        : null}

      {!props.hideClrData ?
        <ClearAll onClick={props.clrSelectedRows}>{t('clearAll')}</ClearAll>
        : null}

      <div class="dropdown">

        <button
          onClick={() => { document.getElementById(`${props.label}`).classList.toggle("show"); }}
          disabled={props.disable}
          class={`dropbtn ${classs.buttonStyle}`}>
          {props.label}
          <DownArrow className="no-point-events" />
        </button>

        <DropDown id={`${props.label}`} className="dropdown-content">
          {props.options.map(val =>
            <DropDownRow
              style={{ display: val?.hide ? 'none' : '' }}
              disabled={val.disable || val.header}
              className={val.header ? classs.btnHeader : ''}
              onClick={() => props.GetChangeAction(val)}
            >{val.label}</DropDownRow>
          )}
        </DropDown>

      </div >

    </ActionDropDownContainer>


  )
}

export default ActionDropDown;